export default __webpack_public_path__ + "static/media/Bus.19cbc609.svg";